import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BiArchiveIn } from "react-icons/bi";
import { useToast } from "../../../components/Toast/ToastContext";
import { logout } from "../../../store/auth/actions";
import { apiErrorMessage, archiveAccount } from "../../../services/settingsApi";
import { Card, dangerButtonClass } from "../settingsUi";

const SUPPORT_EMAIL = "support@vendororbis.com";

const AccountSection = ({ email }: { email: string }) => {
  const { notify } = useToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [archiving, setArchiving] = useState(false);

  const archive = async () => {
    const confirmed = window.confirm(
      `Archive your account?\n\nYou'll be signed out and ${email} won't be able to use VendorOrbis until it's restored. To delete your account and data permanently, email ${SUPPORT_EMAIL}.`
    );
    if (!confirmed) return;
    setArchiving(true);
    try {
      await archiveAccount();
      notify(`Account archived. Email ${SUPPORT_EMAIL} to delete it permanently.`, {
        type: "success",
      });
      dispatch(logout() as any);
      navigate("/");
    } catch (error) {
      notify(apiErrorMessage(error, "Couldn't archive your account."), { type: "error" });
      setArchiving(false);
    }
  };

  return (
    <Card
      icon={BiArchiveIn}
      title="Archive account"
      description={
        <>
          Turns off your account and signs you out. To delete your account and all its data
          permanently, email{" "}
          <a className="text-blue-600 hover:underline" href={`mailto:${SUPPORT_EMAIL}`}>
            {SUPPORT_EMAIL}
          </a>
          .
        </>
      }
    >
      <button type="button" className={dangerButtonClass} onClick={archive} disabled={archiving}>
        {archiving ? "Archiving…" : "Archive account"}
      </button>
    </Card>
  );
};

export default AccountSection;
